import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppointment, getAppointmentClearData, } from "../../../store/appointment/actions";
import { formattedDateWithHour } from "../../../utils/date";
export var useAppointment = function (quoteId, showAppointmentTab) {
    var _a = useState([]), appointmentRows = _a[0], setAppointmentRows = _a[1];
    var _b = useState(""), appointmentId = _b[0], setAppointmentId = _b[1];
    var _c = useState(""), executiveUserId = _c[0], setExecutiveUserId = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a, _b;
        return ({
            responseGetAppointment: (_a = state.Appointment.responseGetAppointment) === null || _a === void 0 ? void 0 : _a.data,
            loadingGetAppointmentAction: (_b = state.Appointment.loadingGetAppointmentAction) === null || _b === void 0 ? void 0 : _b.data,
        });
    }), responseGetAppointment = _d.responseGetAppointment, loadingGetAppointmentAction = _d.loadingGetAppointmentAction;
    // El endpoint /Users?users={id} devuelve una lista paginada,
    // tomamos el primer (y único) elemento.
    var responseGetUserById = useSelector(function (state) {
        var _a, _b;
        return ({
            responseGetUserById: (_b = (_a = state.Login.responseGetUserById) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0],
        });
    }).responseGetUserById;
    var callAppointment = function (quoteId) {
        if (quoteId)
            dispatch(getAppointment({ quoteId: quoteId }));
    };
    useEffect(function () {
        setAppointmentRows([]);
        setExecutiveUserId("");
        if (showAppointmentTab && quoteId) {
            callAppointment(quoteId);
        }
    }, [showAppointmentTab, quoteId]);
    useEffect(function () {
        var _a, _b;
        if (responseGetAppointment) {
            var formattedDate = formattedDateWithHour(responseGetAppointment.appointmentDate);
            var appointment = {
                id: responseGetAppointment.id,
                appointmentDate: formattedDate,
                status: responseGetAppointment.status,
                comment: responseGetAppointment.comment,
                officer: (_a = responseGetAppointment.executiveName) !== null && _a !== void 0 ? _a : "",
                executiveUserId: responseGetAppointment.executiveUserId,
            };
            setAppointmentId(appointment.id);
            setExecutiveUserId((_b = responseGetAppointment.executiveUserId) !== null && _b !== void 0 ? _b : "");
            setAppointmentRows([appointment]);
            dispatch(getAppointmentClearData());
        }
    }, [responseGetAppointment]);
    return {
        appointmentRows: appointmentRows,
        appointmentId: appointmentId,
        setAppointmentRows: setAppointmentRows,
        setAppointmentId: setAppointmentId,
        setExecutiveUserId: setExecutiveUserId,
        executiveUserId: executiveUserId,
        loadingGetAppointmentAction: loadingGetAppointmentAction,
        callAppointment: callAppointment,
    };
};
